import { render, staticRenderFns } from "./PaymentDisputeFilter.vue?vue&type=template&id=a3b5c5ac&"
import script from "./PaymentDisputeFilter.vue?vue&type=script&lang=js&"
export * from "./PaymentDisputeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports